/* eslint-disable */
/* tslint:disable */

import React from 'react';
import { Download } from '@wix/wix-ui-icons-common/on-stage';
const download = _ref => {
  let {} = _ref;
  return /*#__PURE__*/React.createElement(Download, null);
};
download.displayName = 'download';
export default download;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=download.js.map